<div class="app-modal app-modal-simple">
  <div class="auth">
    <div class="login-form">
      <h3>{{ 'general.termsAndConditions' | translate }}</h3>
      <div class="desc">
        {{ 'auth.acceptTermsMessage' | translate }}
        <a class="simple-lnk" (click)="onViewClick()">
          {{ 'general.termsAndConditions' | translate }}
        </a>
      </div>
    </div>
    <div class="login-form form-footer form-footer-big acenter">
      <a
        href="javascript:void(0)"
        class="simple-btn simple-btn-rounded simple-btn-dark-line simple-btn-text-grey simple-btn-md bigger-side-pads"
        (click)="onSignOutClick()">
        <span>{{ 'actions.sign_out' | translate }}</span>
      </a>
      <a
        href="javascript:void(0)"
        class="simple-btn simple-btn-rounded simple-btn-accent simple-btn-md bigger-side-pads simple-btn-shadow"
        (click)="onAcceptClick()">
        <span>{{ 'general.acceptTerms' | translate }}</span>
      </a>
    </div>
  </div>
</div>
